import useSWR from 'swr';
import { getQueriesForClient } from '~/app/_repositories/query-service';
import { parseDate } from '~/models/contest-list-item';
import { convertContestStatus } from '~/models/contest-status';
import { shouldShowNew } from '~/utils/contest';

const fetcher = async () => {
  const REQUEST_ID = `fetch-has-new-contest`;
  const queryServiceResponse = await getQueriesForClient({
    request_list: [
      {
        request_id: REQUEST_ID,
        contest_page_request: {
          require_contest: {
            require_status: true,
            require_open_entry_at: true,
          },
          include_opened: true,
          include_disclosed: true,
          page: {
            page_number: 0,
            limit: 1,
          },
        },
      },
    ],
  });

  const contestPage = queryServiceResponse.response_list.find(
    (item) => item.request_id === REQUEST_ID
  )?.contest_page;

  if (!contestPage) {
    return false;
  }

  const firstContest = contestPage.contest_list?.[0];

  if (!firstContest || !firstContest.open_entry_at || !firstContest.status) {
    return false;
  }

  const openEntryAt = parseDate(firstContest.open_entry_at);
  const status = convertContestStatus(firstContest.status);

  return shouldShowNew({
    openEntryAt,
    status,
  });
};

export const useHasNewContest = () => {
  return useSWR(['/contest/has-new-contest'], fetcher);
};
